import { SHOW_ERRORS, SHOW_LOADER, STOP_LOADER, SHOW_MSG, SET_NOTIFICATION } from 'constants/general.constants';


export const showErrors = (message) => {
    return {
      type: SHOW_ERRORS,
      payload: message
    };
  }; 

  export const showMessage = (message) => {
    return {
      type: SHOW_MSG,
      payload: message
    };
  }; 

  export const startLoader = () => {
    return {
      type: SHOW_LOADER
    };
  };   

  export const stopLoader = (message) => {
    return {
      type: STOP_LOADER,
      payload: message
    };
  };   

  export const setNotification = (notification) => {
    return {
      type: SET_NOTIFICATION,
      notification: notification
    };
  }; 